module.exports = __webpack_public_path__ + "static/media/plan_cn.c65099e8.png";